import useGetContact from '@hooks/native/useGetContact';
import { useTranslation } from 'react-i18next';

function useContact(onUpdate: (name: string, phone: string) => void) {
    const { t } = useTranslation('gift');

    const { openContacts } = useGetContact({
        callbackFn: onUpdate,
        errorMessage: t('giftOrder.contactPermissionDenied'),
    });
    return {
        openContacts,
    };
}

export default useContact;
